import { useEffect, useState } from "react";
import { getAuthString } from "./authStorage";

export function useAuthString(key) {
  const [value, setValue] = useState(() => getAuthString(key));

  useEffect(() => {
    const update = (event) => {
      const changedKey = event?.detail?.key;
      if (changedKey && changedKey !== "*" && changedKey !== key) return;
      setValue(getAuthString(key));
    };

    // Initial read (covers cases where tokens arrive after first render)
    update({ detail: { key: "*" } });

    window.addEventListener("authStorage:changed", update);
    return () => {
      window.removeEventListener("authStorage:changed", update);
    };
  }, [key]);

  return value;
}
